/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainEntitiesAwGameDataViewModel, FxIdDomainEntitiesAwGameDataViewModelFromJSONTyped, FxIdDomainEntitiesAwGameDataViewModelToJSON, } from './FxIdDomainEntitiesAwGameDataViewModel';
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataAwGameDataFromJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataAwGameDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataAwGameDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesAwGameDataViewModel(json)) {
        return FxIdDomainEntitiesAwGameDataViewModelFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataAwGameDataToJSON(json) {
    return FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataAwGameDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataAwGameDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainEntitiesAwGameDataViewModel(value)) {
        return FxIdDomainEntitiesAwGameDataViewModelToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthGameDataAwGameData.js.map